import React from "react";
import { Badge, IndexTable, Link, Page, Text } from "@shopify/polaris";
import { TitleBar } from "@shopify/app-bridge-react";
import { useTranslation } from "react-i18next";
import PlaceTable from "../../components/PlaceTable";

export default function RegionsIndex(props) {
  const { t } = useTranslation();
  
  return (
    <Page fullWidth>
      <TitleBar title={t("regions.title")} breadcrumbs={[]} />
      <PlaceTable
        headings={[
          { title: t("regions.headings.name") },
          { title: t("regions.headings.status") },
          { title: t("regions.headings.locations") },
          { title: t("regions.headings.cities") },
          { title: t("regions.headings.country") },
        ]}
        isLocationList={false}
        url="/regions"
        resourceName={{ singular: t("regions.resourceSingular"), plural: t("regions.resourcePlural") }}
        renderLocation={({
          id,
          url,
          name,
          locations_count,
          cities_count,
          country,
          published,
        }) => (
          <IndexTable.Row key={id} id={id}>
            <IndexTable.Cell>
              <div style={{ padding: "var(--p-space-2) 0px" }}>
                <Link url={url} monochrome removeUnderline>
                  <Text  variant="bodyMd" as="span" fontWeight="semibold">{name}</Text>
                </Link>
              </div>
            </IndexTable.Cell>
            <IndexTable.Cell>
              {published ? (
                <Badge status="success">{t("location.index.published")}</Badge>
              ) : (
                <Badge>{t("location.index.draft")}</Badge>
              )}
            </IndexTable.Cell>
            <IndexTable.Cell>{locations_count}</IndexTable.Cell>
            <IndexTable.Cell>{cities_count}</IndexTable.Cell>
            <IndexTable.Cell>
              <Link monochrome removeUnderline url={country.url}>
                {country.name}
              </Link>
            </IndexTable.Cell>
          </IndexTable.Row>
        )}
      />
    </Page>
  );
}
